const myURL="http://54.152.206.84:8000/";

export default function getPatientList() {
  async function populatePatientList() {
    try {
      let response = await fetch(myURL + 'list/ptids/');
      let mydata = await response.json();
      var longstr = mydata.map(el => '<option value="' + el.id + '" data-value=' + el.ptid + '></option>').join("");
      var datalistelt = document.getElementById('patientlist');
      datalistelt.innerHTML = longstr;
    }
    catch(e) {
      console.log('Error!', e);
    }
  }
  populatePatientList();
}
